export const vesselEngineTrueFalseMApping = {
  true: "Yes",
  false: "No",
};
